<template>
  <div class="date-input-container">
    <Cleave
      v-model="date"
      :raw="false"
      :options="options"
      :placeholder="placeholder"
      :name="name"
      :value="date"
      :class="input_class"
      autocomplete="off"
    />
  </div>
</template>

<script>
import Cleave from 'vue-cleave-component';

export default {
  name: 'DateInput',

  components: {
    Cleave
  },

  props: {
    input_class: { type: String, default: 'input' },
    placeholder: { type: String, default: 'YYYY-MM-DD' },
    value: { type: String, default: null },
    format: { type: String, default: 'YYYY-MM-DD' },
    name: { type: String, default: 'date' }
  },

  data() {
    return {
      date: this.value,
      options: {
        date: true,
        datePattern: ['Y', 'm', 'd'],
        delimiter: '-'
      }
    };
  },

  watch: {
    value(val) {
      this.date = val;
    },
    date(val) {
      this.$emit('input', val);
    }
  }
};
</script>
